import { VAvatar } from 'vuetify/lib/components/VAvatar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAvatar,{staticClass:"mt-2",attrs:{"size":"60"}},[(_vm.imageFileName)?_c('api-image',{attrs:{"bucket":_vm.imageBucket,"file-name":_vm.imageFileName}}):_c('span',[_vm._v(_vm._s(_vm.initials))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }